import {Component, Input, OnInit} from '@angular/core';
import {ProductQuery, SearchProductResponse} from '@services/resource/search-product-resources';
import {Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {QueryAndIndex, SearchproductService} from '@services/searchproduct.service';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {CommonModule} from '@angular/common';
import {MarkantElementsModule} from '@markant/elements-angular';

class NavLink {
  constructor(
    public url: string,
    public query: ProductQuery,
  ) {}
}

@Component({
  selector: 'app-product-nav',
  templateUrl: './product-nav.component.html',
  styleUrls: ['./product-nav.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, MarkantElementsModule],
})
export class ProductNavComponent implements OnInit {
  SearchProductRequest = ProductQuery;

  @Input() direction: 'left' | 'right';
  @Input() query: ProductQuery;

  queryAndIndex$: Observable<QueryAndIndex>;
  link$: Observable<NavLink | null>;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly searchproductService: SearchproductService,
  ) {}

  ngOnInit() {
    this.queryAndIndex$ = this.route.queryParamMap.pipe(SearchproductService.extractQueryAndIndex());
    this.link$ = this.direction === 'left' ? this.mkLinkFromQuery(this.leftNeighbor) : this.mkLinkFromQuery(this.rightNeighbor);
  }

  private mkLinkFromQuery(f: (qi: QueryAndIndex) => ProductQuery): Observable<NavLink | null> {
    return this.queryAndIndex$.pipe(
      map((x) => f(x)),
      switchMap((q) => this.searchproductService.search(q)),
      map((r: SearchProductResponse) => {
        if (r.results.length === 0) {
          return null;
        }
        const e = r.results[0];
        const url = `../${e.product.id}`;
        return new NavLink(url, r.query);
      }),
    );
  }

  /* for any given request and index, build a request that queries exactly the element left of the index */
  private leftNeighbor(qi: QueryAndIndex): ProductQuery {
    /* Note: Negative offsets are filtered out at the service level */
    const newOffset = qi.query.offset + qi.index - 1;
    return {...qi.query, offset: newOffset, limit: 1};
  }

  private rightNeighbor(qi: QueryAndIndex): ProductQuery {
    const newOffset = qi.query.offset + qi.index + 1;
    return {...qi.query, offset: newOffset, limit: 1};
  }
}
